import { environment } from '../../../../environments/environment';


export const VersionSettings = {
     get versionNumber(): string { return '4.8.3.7'; },
     get isProduction(): boolean { return environment.production; },
};
